export const calculateReadingTime = (text) => {
  const wordsPerMinute = 200; // Baseline WPM
  const words = text?.trim()?.split(/\s+/).length; // Split by whitespace to count words
  const readingTime = Math.ceil(words / wordsPerMinute);
  return readingTime + " min read";
};

export const cleanArticleHtml = (html = "") => {
  return html.replace(
    /<script type="application\/ld\+json">[\s\S]*?<\/script>/gi, ""
  );
};

export const insertMetaIntoContent = (
  html,
  metaHtml
) => {
  if (!html) return metaHtml;

  // Find first image
  const firstImgIndex = html.indexOf("<img");

  if (firstImgIndex === -1) {
    // No image → prepend meta
    return `
      ${metaHtml}
      ${html}
    `;
  }

  // Find end of first image tag
  const imgEndIndex = html.indexOf(
    ">",
    firstImgIndex
  );

  if (imgEndIndex === -1) {
    return `
      ${metaHtml}
      ${html}
    `;
  }

  // Insert after image
  return (
    html.slice(0, imgEndIndex + 1) +
    metaHtml +
    html.slice(imgEndIndex + 1)
  );
};

export const cleanFooterLinks = (
  html = ""
) => {

  return html.replace(

    /(<h2 id="recommended"[\s\S]*?<ul>)([\s\S]*?)(<\/ul>)/i,

    (
      match,
      start,
      listContent,
      end
    ) => {

      const updatedList =
        listContent.replace(

          /<a([^>]+href=["']([^"']+)["'][^>]*)>(.*?)<\/a>/gi,

          (
            linkMatch,
            attributes,
            href
          ) => {

            // Remove trailing slash
            const cleanedHref =
              href.replace(/\/$/, "");

            const parts =
              cleanedHref.split("/");

            const lastPart =
              parts.pop();

            // If only domain exists
            const isHomepage =
              !lastPart ||
              lastPart.includes("upncomer.co");

            let readableText =
              "UpNComer";

            // If slug exists
            if (!isHomepage) {

              readableText =
                lastPart
                  ?.replaceAll("-", " ")
                  ?.replace(
                    /\b\w/g,
                    (c) =>
                      c.toUpperCase()
                  );
            }

            return `
              <a${attributes}>
                ${readableText}
              </a>
            `;
          }
        );

      return `
        ${start}
        ${updatedList}
        ${end}
      `;
    }
  );
};

export const generateArticleFooter = ({
  keywords = [],
}) => {
  const keywordPills = keywords
    .map(
      (keyword) => `
        <span class="article-keyword-pill">
          ${keyword}
        </span>
      `
    )
    .join("");

  return `
    <div class="article-footer-section">

      ${keywords.length
      ? `
        <div class="article-keywords-wrapper">
          <div class="article-footer-title">
            Related Topics
          </div>

          <div class="article-keywords">
            ${keywordPills}
          </div>
        </div>
      `
      : ""
    }
    </div>
  `;
};

export const optimizeArticleHtml = (
  html = "",
  heroImage = ""
) => {
  if (!html) return "";

  let imageIndex = 0;

  return html.replace(
    /<img([^>]*?)src=["']([^"']+)["']([^>]*?)>/gi,
    (match, beforeSrc, src, afterSrc) => {
      const isHero =
        src === heroImage ||
        imageIndex === 0;

      imageIndex++;

      // Responsive sizing
      const optimizedSrc =
        `${src}${src.includes("?") ? "&" : "?"}w=1200`;

      const srcSet = `
                ${src}${src.includes("?") ? "&" : "?"}w=480 480w,
                ${src}${src.includes("?") ? "&" : "?"}w=768 768w,
                ${src}${src.includes("?") ? "&" : "?"}w=1200 1200w
            `;

      return `
                <img
                    ${beforeSrc}
                    src="${optimizedSrc}"
                    srcset="${srcSet}"
                    sizes="(max-width: 768px) 100vw, 1200px"

                    alt="Article image"

                    width="1200"
                    height="630"

                    loading="${isHero
          ? "eager"
          : "lazy"
        }"

                    fetchpriority="${isHero
          ? "high"
          : "auto"
        }"

                    decoding="async"

                    style="
                        width:100%;
                        height:auto;
                        aspect-ratio:16/9;
                    "

                    ${afterSrc}
                />
            `;
    }
  );
};